<template>
  <div>
    <div class="right-title">
      <span>候选人详情</span>
      <div class="conten-btn-box">
        <el-button class="conter-btn" type="success" v-if="isShenhe" @click="shenhe(0)">通过</el-button>
        <el-button class="conter-btn" type="danger" v-if="isShenhe" @click="shenhe(1)">拒绝</el-button>
      </div>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box2">
      <div class="mode-box">
        <p class="mode-title">基本信息 <span @click="setStatus">{{userInfo.status===1?'设置为信任':'设置为不信任'}}</span>
          <span @click="setScode"
                style="border:1px solid #d50000; color: #d50000;    width: 300px; margin-right: 10px;">高佣邀请码：{{userInfo.vip_invitation_code}}</span></p>
        <div class="info-box-all">
          <div class="info-img">
            <img :src="userInfo.headimg" alt="">
          </div>
          <div class="info-box">
            <div>
              <span class="left">姓名：</span>
              <span>{{userInfo.user_real_name}}</span>
            </div>
            <div>
              <span class="left">性别：</span>
              <span>{{!userInfo.sex?'':(userInfo.sex === 1?'男':'女')}}</span>
            </div>
            <div>
              <span class="left">出生年月：</span>
              <span>{{!userInfo.birthday?'':userInfo.birthday}}</span>
            </div>
            <!--          <div>-->
            <!--            <span class="left">工作年限：</span>-->
            <!--            <span></span>-->
            <!--          </div>-->
            <div>
              <span class="left">邮箱：</span>
              <span>{{userInfo.email}}</span>
            </div>
            <!--          <div>-->
            <!--            <span class="left">学历：</span>-->
            <!--            <span></span>-->
            <!--          </div>-->
            <div>
              <span class="left">所在地：</span>
              <span>{{userInfo.address_name}}</span>
            </div>
            <div>
              <span class="left">电话：</span>
              <span>{{userInfo.phone}}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="mode-box">
        <p class="mode-title"><i class="iconfont iconshouqi"></i>简历</p>
        <div class="resume-item" v-for="(item,index) in resume" :key="index">
          <div class="left-text">
            <span class="name ovDna">{{item.title}}</span>
            <span class="time">最后编辑时间：{{item.update_time}}</span>
          </div>
          <div class="right-text">
            <span @click="toResumeDetial(item.id)">预览</span>
            <span @click="toResemeDetele(item.id)">删除</span>
          </div>
        </div>
      </div>
      <div class="mode-box">
        <p class="mode-title"><i class="iconfont iconshouqi"></i>求职信</p>
        <div class="resume-item" v-for="(item,index) in qiuzhi" :key="index">
          <div class="left-text">
            <span class="name ovDna">{{item.title}}</span>
          </div>
          <div class="right-text">
            <span @click="toQinzhiDetial(item.id)">预览</span>
            <span @click="toQinzhiDetele(item.id)">删除</span>
          </div>
        </div>
      </div>
    </div>


    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import config from '../../../../config/index'

  export default {
    name: "hxrDetail",
    data() {
      return {
        isShenhe: false,    //  是否显示审核
        userInfo: {
          address_name: '',
          birthday: '',
          email: '',
          headimg: '',
          phone: '',
          sex: '',
          user_real_name: '',
          vip_invitation_code:'',  //  邀请码
          status: 0//  候选人状态
        },
        resume: [],
        qiuzhi: []
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (this.$route.query.shenhe) {
        this.isShenhe = true
      }
      // this.$emit('setType', 0)
      this.init()
    },
    methods: {
      //  点击更换邀请码
      setScode(){
        this.$confirm('是否确定变更邀请码？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.refreshUserInvitationCode({
            adminId: this.user.id,
            userId: this.$route.params.id
          }).then(() => {
            this.init()
          })
        }).catch(() => {

        });

      },
      //  获取候选人信息
      init() {
        this.$api.apiContent.hxrDetail({
          admin_id: this.user.id,
          user_id: this.$route.params.id
        }).then(res => {
          this.userInfo = res.data.Jbxx
          this.userInfo.headimg = config.urlStr + '/' + this.userInfo.headimg
          this.userInfo.birthday = !this.userInfo.birthday?'':this.$tools.ZHDate(new Date(this.userInfo.birthday * 1000))
          let _list1 = res.data.Janli
          _list1.map(item => {
            if (item.update_time === 0) item.update_time = item.create_time
            item.update_time = this.$tools.ZHDate(new Date(item.update_time * 1000), 1)
          })
          this.resume = _list1
          this.qiuzhi = res.data.Qzx
          console.log(this.qiuzhi)
        }).catch(e => {
          this.$message.error(e.info)
        })
      },
      //  基本信息审核
      shenhe(state) {      //  0 通过 1 拒绝
        if(state === 0){
          this.$confirm('您确定要审核通过吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.apiContent.shenheUserInfo({
              admin_id: this.user.id,
              user_id: this.$route.params.id,
              tg: state
            }).then(() => {
              this.$message.success('审核完成')
              this.goBack()
            }).catch(e => {
              this.$message.error(e.info)
            })
          }).catch(() => {
          })
        }else {
          this.$prompt('请填写拒绝理由', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({value}) => {
            this.$api.apiContent.shenheUserInfo({
              admin_id: this.user.id,
              user_id: this.$route.params.id,
              tg: state,
              delContent:value
            }).then(() => {
              this.$message.success('审核完成')
              this.goBack()
            }).catch(e => {
              this.$message.error(e.info)
            })
          }).catch();
        }






        // let _str = state === 0 ? '您确定要审核通过吗？' : '您确定要拒绝吗？'
        // this.$confirm(_str, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$api.apiContent.shenheUserInfo({
        //     admin_id: this.user.id,
        //     user_id: this.$route.params.id,
        //     tg: state
        //   }).then(() => {
        //     this.$message.success('审核完成')
        //     this.goBack()
        //   }).catch(e => {
        //     this.$message.error(e.info)
        //   })
        // }).catch(() => {
        // })
      },
      //  设置候选人 信任状态
      setStatus() {
        this.$confirm('确定要修改候选人的状态吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgTrust({
            user_id: this.$route.params.id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.init()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //  去候选人简历详情
      toResumeDetial(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrResume',
          query: {
            resumeId: id
          }
        })
      },
      //  删除候选人简历
      toResemeDetele(id) {

        this.$prompt('请填写删除理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.$api.apiContent.toResemeDetele({
            id: id,
            admin_id: this.user.id,
            delContent: value
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.init()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch();
        // this.$confirm('确定要删除候选人的简历吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$api.apiContent.toResemeDetele({
        //     id: id,
        //     admin_id: this.user.id
        //   }).then(res => {
        //     this.$message({
        //       type: 'success',
        //       message: res.info
        //     });
        //     this.init()
        //   }).catch(res => {
        //     this.$message.error(res.info);
        //   })
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消'
        //   });
        // });
      },
      //  去候选人求职信详情
      toQinzhiDetial(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrEmail',
          query: {
            emailId: id
          }
        })
      },
      //  删除候选人求职信
      toQinzhiDetele(id) {
        this.$prompt('请填写删除理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.$api.apiContent.toQinzhiDetele({
            id: id,
            admin_id: this.user.id,
            delContent: value
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.init()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch();
        // this.$confirm('确定要删除候选人的求职信吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$api.apiContent.toQinzhiDetele({
        //     id: id,
        //     admin_id: this.user.id
        //   }).then(res => {
        //     this.$message({
        //       type: 'success',
        //       message: res.info
        //     });
        //     this.init()
        //   }).catch(res => {
        //     this.$message.error(res.info);
        //   })
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消'
        //   });
        // });
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {},
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .right-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .conten-btn-box {
      .conter-btn {
        height: 30px;
        padding: 0 15px;
      }
    }
  }

  .mode-box {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;

    .mode-title {
      line-height: 40px;
      font-size: 18px;

      i {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: #00a2ea;
      }

      span {
        float: right;
        width: 150px;
        line-height: 40px;
        border: 1px solid #00a2ea;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
      }
    }

    .info-box-all {
      display: flex;
      align-items: center;

      .info-img {
        width: 120px;
        height: 150px;

        img {
          display: block;
          width: 120px;
          height: 150px;
        }
      }

      .info-box {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        padding-left: 30px;

        div {
          width: 50%;
          line-height: 40px;

          .left {
            color: #999;
          }
        }
      }
    }


    .resume-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      padding-left: 40px;
      border-bottom: 1px solid #ddd;

      .left-text {
        width: 600px;

        .name {
          width: 390px;
          margin-right: 10px;
        }

        .time {
          color: #999;
          width: 200px;
        }
      }

      .right-text {
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px;

        span {
          display: block;
          color: #00a2ea;
          cursor: pointer;
        }
      }
    }
  }
</style>